export default {"src":"/_next/static/media/playoff-pair-winner.2b0fcbac.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};